/*! 
 * jQuery Magnify Plugin v2.3.3 by T. H. Doan (https://thdoan.github.io/magnify/)
 * Based on http://thecodeplayer.com/walkthrough/magnifying-glass-for-images-using-jquery-and-css3
 * 
 * jQuery Magnify by T. H. Doan is licensed under the MIT License.
 * Read a copy of the license in the LICENSE file or at https://choosealicense.com/licenses/mit/
 * 
 * MOBILE FIX APPLIED - Lens stays visible on mobile like desktop
 * FLICKITY FIX APPLIED - Flickity drag disabled during zoom on desktop
 */
(function($) {
  $.fn.magnify = function(oOptions) {
    // Default options
    oOptions = $.extend({
      'src': '',
      'speed': 100,
      'timeout': -1,
      'touchBottomOffset': 0,
      'finalWidth': null,
      'finalHeight': null,
      'magnifiedWidth': null,
      'magnifiedHeight': null,
      'limitBounds': false,
      'mobileCloseEvent': 'touchend',
      // *** YAHAN APNA FLICKITY CAROUSEL SELECTOR DAALEIN ***
      // Maslan: '.product-gallery', '.main-carousel', '[data-flickity]'
      'flickitySelector': '.flickity-slider, [data-flickity], .main-carousel',
      'afterLoad': function(){}
    }, oOptions);

    var $that = this,
      $html = $('html'),
      isMobile = /\b(Android|BlackBerry|IEMobile|iPad|iPhone|Mobile|Opera Mini)\b/.test(navigator.userAgent),

      // ---- FLICKITY HELPER FUNCTIONS ----
      getFlickity = function($container) {
        // Pehle parent carousel dhundho
        var $carousel = $container.closest(oOptions['flickitySelector']);
        if (!$carousel.length) {
          // Agar Flickity wrapper ko sirf class se dhundna ho
          $carousel = $container.closest('[class*="carousel"], [class*="slider"], [class*="flickity"]');
        }
        if ($carousel.length && typeof Flickity !== 'undefined') {
          return Flickity.data($carousel[0]);
        }
        return null;
      },

      disableFlickityDrag = function($container) {
        var flkty = getFlickity($container);
        if (flkty) {
          flkty.options.draggable = false;
          flkty.unbindDrag && flkty.unbindDrag();
        }
      },

      enableFlickityDrag = function($container) {
        var flkty = getFlickity($container);
        if (flkty) {
          flkty.options.draggable = true;
          flkty.bindDrag && flkty.bindDrag();
        }
      },
      // ---- END FLICKITY HELPERS ----

      // Initiate
      init = function(el) {
        var $image = $(el),
          $anchor = $image.closest('a'),
          oDataAttr = {};
          
        // Get data attributes
        for (var i in oOptions) {
          oDataAttr[i] = $image.attr('data-magnify-' + i.toLowerCase());
        }
        
        // Disable zooming if no valid large image source
        var sZoomSrc = oDataAttr['src'] || oOptions['src'] || $anchor.attr('href') || '';
        if (!sZoomSrc) return;
        
        var $container,
          $lens,
          nImageWidth,
          nImageHeight,
          nMagnifiedWidth,
          nMagnifiedHeight,
          nLensWidth,
          nLensHeight,
          nBoundX = 0,
          nBoundY = 0,
          nPosX,
          nPosY,
          nX,
          nY,
          oContainerOffset,
          oImageOffset,
          touchTimeout = null,
          isTouch = false,
          
          // Get true offsets
          getOffset = function() {
            var o = $container.offset();
            oImageOffset = {
              'top': ($image.offset().top-o.top) + parseInt($image.css('border-top-width')) + parseInt($image.css('padding-top')),
              'left': ($image.offset().left-o.left) + parseInt($image.css('border-left-width')) + parseInt($image.css('padding-left'))
            };
            o.top += oImageOffset['top'];
            o.left += oImageOffset['left'];
            return o;
          },
          
          // Hide the lens
          hideLens = function() {
            if (touchTimeout) {
              clearTimeout(touchTimeout);
              touchTimeout = null;
            }
            isTouch = false;
            if ($lens.is(':visible')) {
              $lens.fadeOut(oOptions['speed'], function() {
                $html.removeClass('magnifying').trigger('magnifyend');
              });
            }
          },
          
          moveLens = function(e) {
            // Reinitialize if image initially hidden
            if (!nImageHeight) {
              refresh();
              return;
            }
            
            if (e) {
              e.preventDefault();
              
              // Handle both mouse and touch events
              if (e.type === 'touchmove' || e.type === 'touchstart') {
                if (e.originalEvent.touches && e.originalEvent.touches.length > 0) {
                  nPosX = e.originalEvent.touches[0].pageX;
                  nPosY = e.originalEvent.touches[0].pageY;
                  isTouch = true;
                } else {
                  return;
                }
              } else {
                nPosX = e.pageX;
                nPosY = e.pageY;
                isTouch = false;
              }
              
              $image.data('lastPos', {
                'x': nPosX,
                'y': nPosY
              });
            } else {
              var lastPos = $image.data('lastPos');
              if (!lastPos) return;
              nPosX = lastPos.x;
              nPosY = lastPos.y;
            }
            
            nX = nPosX - oContainerOffset['left'];
            nY = (nPosY - oContainerOffset['top']) - oOptions['touchBottomOffset'];
            
            // Toggle magnifying lens
            if (!$lens.is(':animated')) {
              if (nX>nBoundX && nX<nImageWidth-nBoundX && nY>nBoundY && nY<nImageHeight-nBoundY) {
                $lens.fadeIn(oOptions['speed'], function() {
                  $html.addClass('magnifying').trigger('magnifystart');
                });
              } else {
                if (!isTouch) {
                  hideLens();
                }
              }
            }
            
            if ($lens.is(':visible')) {
              var nRatioX = (nMagnifiedWidth - nImageWidth) / nImageWidth,
                nRatioY = (nMagnifiedHeight - nImageHeight) / nImageHeight,
                nBackgroundX = -(nX * nRatioX) + (nLensWidth/2),
                nBackgroundY = -(nY * nRatioY) + (nLensHeight/2);
              
              if (oOptions['limitBounds']) {
                if (nRatioX>0) nRatioX = 0;
                else if (nRatioX<-1) nRatioX = -1;
                if (nRatioY>0) nRatioY = 0;
                else if (nRatioY<-1) nRatioY = -1;
              }
              
              $lens.css({
                'left': nX - (nLensWidth/2) + oImageOffset['left'],
                'top': nY - (nLensHeight/2) + oImageOffset['top'],
                'background-position': nBackgroundX + 'px ' + nBackgroundY + 'px'
              });
            }
          };
        
        // Append image to magnifying lens
        var elZoomImage = new Image();
        
        $(elZoomImage).on({
          'load': function() {
            // Create container div if necessary
            if (!$image.parent('.magnify').length) {
              $image.wrap('<div class="magnify"></div>');
            }
            $container = $image.parent('.magnify');
            
            // Create the magnifying lens div if necessary
            if ($image.prev('.magnify-lens').length) {
              $container.children('.magnify-lens').css('background-image', 'url(\'' + sZoomSrc + '\')');
            } else {
              $image.before('<div class="magnify-lens loading"></div>');
            }
            $lens = $container.children('.magnify-lens');
            $lens.removeClass('loading');
            
            // Cache dimensions
            nImageWidth = oOptions['finalWidth'] || $image.width();
            nImageHeight = oOptions['finalHeight'] || $image.height();
            nMagnifiedWidth = oOptions['magnifiedWidth'] || elZoomImage.width;
            nMagnifiedHeight = oOptions['magnifiedHeight'] || elZoomImage.height;
            nLensWidth = $lens.width();
            nLensHeight = $lens.height();
            oContainerOffset = getOffset();
            
            if (oOptions['limitBounds']) {
              nBoundX = (nLensWidth/2) / (nMagnifiedWidth/nImageWidth);
              nBoundY = (nLensHeight/2) / (nMagnifiedHeight/nImageHeight);
            }
            
            if (nMagnifiedWidth!==elZoomImage.width || nMagnifiedHeight!==elZoomImage.height) {
              $lens.css('background-size', nMagnifiedWidth + 'px ' + nMagnifiedHeight + 'px');
            }
            
            $image.data('zoomSize', {
              'width': nMagnifiedWidth,
              'height': nMagnifiedHeight
            });
            
            $container.data('mobileCloseEvent', oDataAttr['mobileCloseEvent'] || oOptions['mobileCloseEvent']);
            
            elZoomImage = null;
            oOptions.afterLoad();
            
            if ($lens.is(':visible')) moveLens();
            
            if (isMobile) {
              // Mobile: lens stays visible during touch, hides on touchend
              $container.off().on({
                'touchstart': function(e) {
                  if (touchTimeout) {
                    clearTimeout(touchTimeout);
                    touchTimeout = null;
                  }
                  oContainerOffset = getOffset();
                  moveLens(e);
                },
                'touchmove': function(e) {
                  if (touchTimeout) {
                    clearTimeout(touchTimeout);
                    touchTimeout = null;
                  }
                  moveLens(e);
                },
                'touchend': function() {
                  hideLens();
                },
                'touchcancel': function() {
                  hideLens();
                }
              });
              
              $('body').on('touchstart.magnify', function(e) {
                if (!$(e.target).closest($container).length && $lens.is(':visible')) {
                  hideLens();
                }
              });

            } else {
              // =============================================
              // DESKTOP: Flickity drag disable fix
              // =============================================
              $container.off().on({
                'mouseenter': function() {
                  oContainerOffset = getOffset();
                  // Zoom shuru hone par Flickity drag band karo
                  disableFlickityDrag($container);
                },
                'mouseleave': function() {
                  hideLens();
                  // Zoom khatam hone par Flickity drag wapas chalao
                  enableFlickityDrag($container);
                },
                'mousemove': moveLens
              });
              // =============================================
            }
            
            // Support image map click-throughs
            var sUsemap = $image.attr('usemap');
            if (sUsemap) {
              var $map = $('map[name=' + sUsemap.slice(1) + ']');
              $image.after($map);
              $container.click(function(e) {
                var clientX = e.clientX || (e.originalEvent.touches && e.originalEvent.touches[0] ? e.originalEvent.touches[0].clientX : null);
                var clientY = e.clientY || (e.originalEvent.touches && e.originalEvent.touches[0] ? e.originalEvent.touches[0].clientY : null);
                if (clientX || clientY) {
                  $lens.hide();
                  var elPoint = document.elementFromPoint(clientX, clientY);
                  if (elPoint && elPoint.nodeName==='AREA') {
                    elPoint.click();
                  } else {
                    $('area', $map).each(function() {
                      var a = $(this).attr('coords').split(',');
                      if (nX>=a[0] && nX<=a[2] && nY>=a[1] && nY<=a[3]) {
                        this.click();
                        return false;
                      }
                    });
                  }
                }
              });
            }
            
            if ($anchor.length) {
              $anchor.css('display', 'inline-block');
              if ($anchor.attr('href') && !(oDataAttr['src'] || oOptions['src'])) {
                $anchor.click(function(e) {
                  e.preventDefault();
                });
              }
            }
          },
          'error': function() {
            elZoomImage = null;
          }
        });
        
        elZoomImage.src = sZoomSrc;
      },
      
      nTimer = 0,
      refresh = function() {
        clearTimeout(nTimer);
        nTimer = setTimeout(function() {
          $that.destroy();
          $that.magnify(oOptions);
        }, 100);
      };
    
    /**
     * Public Methods
     */
    this.destroy = function() {
      this.each(function() {
        var $this = $(this),
          $lens = $this.prev('div.magnify-lens'),
          sStyle = $this.data('originalStyle');
        if ($this.parent('div.magnify').length && $lens.length) {
          if (sStyle) $this.attr('style', sStyle);
          else $this.removeAttr('style');
          $this.unwrap();
          $lens.remove();
        }
      });
      $(window).off('resize', refresh);
      $('body').off('touchstart.magnify');
      return $that;
    };
    
    $(window).resize(refresh);
    
    return this.each(function() {
      init(this);
    });
  };
}(jQuery));